<template>
  <svg
    width="68"
    height="68"
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="34"
      cy="34"
      r="34"
      transform="rotate(-180 34 34)"
      fill="#7B90FF"
    />
    <rect
      x="29.666"
      y="12.667"
      width="10"
      height="10"
      fill="white"
    />
    <rect
      x="29.666"
      y="28.667"
      width="10"
      height="26"
      fill="white"
    />
  </svg>
</template>
